import { ObjectId } from 'bson';
import { Transform, Type } from 'class-transformer';
import {
  ArrayMinSize,
  IsArray,
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { FileId } from '../../../../types';
import { PropertyFileDto } from './property-file-dto';

export class PropertyCharacteristicRefDto {
  @IsString()
  section!: 'interior' | 'exterior' | 'commonAreas' | 'parkings' | 'general';

  @IsString()
  category!: string;

  @IsString()
  id!: string;
}

export class PropertyPhotoDto {
  @Transform(({ value }) => (value && typeof value === 'string' ? new ObjectId(value) : value))
  @IsOptional()
  file?: FileId | PropertyFileDto;

  @IsString()
  @IsOptional()
  url?: string;

  @IsNumber()
  order!: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => PropertyCharacteristicRefDto)
  characteristicRef?: PropertyCharacteristicRefDto;

  @IsOptional()
  @IsBoolean()
  isHiddenBeforeMandate?: boolean;
}

export class PropertyAddMediaDto {
  @IsArray()
  @ArrayMinSize(1, { message: 'At least one photo is mandatory' })
  @ValidateNested({ each: true })
  @Type(() => PropertyPhotoDto)
  photos!: PropertyPhotoDto[];
}

export class PropertyMediaDto {
  @Transform(({ value }) => (value && typeof value === 'string' ? new ObjectId(value) : value))
  coverPhoto!: FileId | PropertyFileDto;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => PropertyPhotoDto)
  photos: PropertyPhotoDto[] = [];
}
